import ProductDescription from './ProductDescription'

const BSWholeWheatEnglishMuffinsProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '011',
  IsBroadband: false,
  Size: '',
}

export default BSWholeWheatEnglishMuffinsProduct
